/**
 * The name shapes that exist, one entry each.
 *
 * A roll picks a shape from here and then asks it for a name, so a third shape is a file and a line
 * rather than a branch in whatever does the rolling.
 */

import { ADJECTIVE_NOUN } from '@/identity/namePatterns/adjectiveNoun';
import { RANK_NOUN } from '@/identity/namePatterns/rankNoun';
import type { NamePattern } from '@/identity/playerNameContract';

export const NAME_PATTERNS: readonly NamePattern[] = [ADJECTIVE_NOUN, RANK_NOUN];
